import React from "react"
import TickingNumber from "../TickingNumber.jsx"
import Reveal from "../Reveal.jsx"

// Big scarcity counter. "X of 100 spots claimed" with a smaller
// "Y left" framing below. Uses the existing TickingNumber animation
// so the count moves visibly as new webshops sign up while the
// visitor is reading. Closed state ("100 of 100") replaces the CTA
// row with a "fully claimed" notice elsewhere; this component only
// renders the numbers.
export default function PromoCounter({ spotsRemaining, spotsTotal, status = "open" }) {
  const total = spotsTotal || 100
  const remaining = typeof spotsRemaining === "number" ? spotsRemaining : total
  const claimed = total - remaining
  const closed = status === "closed" || remaining <= 0

  return (
    <section className="border-t border-[color:var(--color-rule)] bg-[color:var(--color-surface-card)]">
      <div className="max-w-6xl mx-auto px-6 py-24">
        <Reveal>
          <p className="font-mono text-[10px] tracking-[0.15em] uppercase text-[color:var(--color-ai)] mb-6">
            § 02 · Live count
          </p>
        </Reveal>

        <Reveal delay={80}>
          <div className="flex items-baseline gap-x-6 gap-y-4 flex-wrap">
            <div
              className="font-sans font-medium text-[color:var(--color-ink-primary)] leading-none"
              style={{ fontSize: "clamp(96px, 18vw, 220px)", letterSpacing: "-0.05em", fontVariantNumeric: "tabular-nums" }}
            >
              <TickingNumber value={claimed} />
            </div>
            <div className="flex flex-col">
              <span className="font-mono text-[11px] tracking-[0.12em] uppercase text-[color:var(--color-ink-tertiary)]">
                of {total}
              </span>
              <span className="font-sans text-[24px] tracking-[-0.025em] text-[color:var(--color-ink-secondary)] mt-1">
                webshops have claimed it
              </span>
            </div>
          </div>
        </Reveal>

        <Reveal delay={160}>
          <p className="mt-12 font-sans text-[18px] tracking-[-0.015em] text-[color:var(--color-ink-secondary)] max-w-2xl leading-[1.5]">
            {closed
              ? "Every spot is claimed. New signups go to the standard $99/month plan — the 30-day free trial still applies."
              : <>Once {total} webshops have signed up, the 50%-off code closes. Standard $99/month resumes for everyone after that.</>}
          </p>
        </Reveal>

        <Reveal delay={220}>
          <div className="mt-10 inline-flex items-center gap-3 font-mono text-[11px] tracking-[0.04em] text-[color:var(--color-ink-faint)]">
            <span
              className={`inline-block w-1.5 h-1.5 rounded-full ${closed ? "bg-[color:var(--color-archived)]" : "bg-[color:var(--color-winner-dot)]"}`}
              style={closed ? {} : { animation: "pulse 2s ease-in-out infinite" }}
            />
            <span>{closed ? "Promo closed" : "Updating live"}</span>
            <span className="text-[color:var(--color-ink-faint)]">·</span>
            <span>{remaining} spots left</span>
          </div>
        </Reveal>

        <style>{`
          @keyframes pulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.4; }
          }
        `}</style>
      </div>
    </section>
  )
}
